var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-book-plus-multiple",
      show: _vm.dialog,
      maxWidth: "40%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "9" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            autofocus: "",
                            error: !!_vm.errors.name,
                            "error-messages": _vm.errors.name,
                            label: "Nome*",
                          },
                          model: {
                            value: _vm.model.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "name", $$v)
                            },
                            expression: "model.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            code: "",
                            "error-messages": _vm.errors.code,
                            label: "Código",
                          },
                          model: {
                            value: _vm.model.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "code", $$v)
                            },
                            expression: "model.code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-occurrence-nature", {
                          attrs: {
                            model: _vm.model.occurrence_nature_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.occurrence_nature_id,
                            label: "Natureza da Ocorrência*",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "occurrence_nature_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-occurrence-status", {
                          attrs: {
                            model: _vm.model.occurrence_status_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.occurrence_status_id,
                            label: "Status Padrão",
                            clearable: "",
                            natureId: _vm.model.occurrence_nature_id,
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "occurrence_status_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-occurrence-absence", {
                          attrs: {
                            model: _vm.model.occurrence_absence_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.occurrence_absence_id,
                            label: "Ausência/Banco de Horas",
                            clearable: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "occurrence_absence_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("sys-select-occurrence-sheet-type", {
                          attrs: {
                            model: _vm.model.occurrence_record_type_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.occurrence_record_type_id,
                            label: "Tipo de Registro",
                            clearable: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "occurrence_record_type_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            "error-messages": _vm.errors.description,
                            label: "Descrição",
                            counter: 255,
                            rules: [
                              (v) =>
                                !v ||
                                v.length <= 255 ||
                                "Máximo de 255 caracteres atingido",
                            ],
                            outlined: "",
                          },
                          model: {
                            value: _vm.model.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "description", $$v)
                            },
                            expression: "model.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            "error-messages": _vm.errors.link,
                            label: "Link",
                            clearable: "",
                          },
                          model: {
                            value: _vm.model.link,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "link", $$v)
                            },
                            expression: "model.link",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-switch", {
                          attrs: { inset: "", label: "Permitir Validação" },
                          model: {
                            value: _vm.model.allow_editing,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "allow_editing", $$v)
                            },
                            expression: "model.allow_editing",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-switch", {
                          attrs: { inset: "", label: "Requer atestado" },
                          model: {
                            value: _vm.model.requires_certificate,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "requires_certificate", $$v)
                            },
                            expression: "model.requires_certificate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Evento utilizado para incluir uma nova ocorrência",
                            label: "Adicional",
                          },
                          model: {
                            value: _vm.model.is_additional,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "is_additional", $$v)
                            },
                            expression: "model.is_additional",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Evento utilizado informação de feriado",
                            label: "Feriado",
                          },
                          model: {
                            value: _vm.model.is_holiday,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "is_holiday", $$v)
                            },
                            expression: "model.is_holiday",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Ocorrência automática para os registros pré-assinalados",
                            label: "Pré-Assinalada",
                          },
                          model: {
                            value: _vm.model.pre_marked,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "pre_marked", $$v)
                            },
                            expression: "model.pre_marked",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Requer informar o motivo ao registrar a ocorrência",
                            label: "Motivo Obrigatório",
                          },
                          model: {
                            value: _vm.model.requires_motive,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "requires_motive", $$v)
                            },
                            expression: "model.requires_motive",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("s-switch", {
                          attrs: {
                            inset: "",
                            "text-helper":
                              "Quando marcado, impede alterações nas marcações de ponto após registrar esta ocorrência",
                            label: "Bloquear Marcações",
                          },
                          model: {
                            value: _vm.model.block_marks_on_register,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "block_marks_on_register",
                                $$v
                              )
                            },
                            expression: "model.block_marks_on_register",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-switch", {
                          attrs: { inset: "", label: "Ativo" },
                          model: {
                            value: _vm.model.active,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "active", $$v)
                            },
                            expression: "model.active",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }